import type { IGetProfileResponse, IUserProfile } from 'containers/user-profile/types'

import { createContext, useContext, useEffect, useState } from 'react'

import { userApiInstance } from 'api'
import { authService } from 'auth'
import { AuthProviderContext } from 'containers/auth/auth-provider'
import tracker from 'tracker'

export const UserProfileContext = createContext<IUserProfile>({})

export const UserProfileProvider: React.FC<{
  children: React.ReactNode
}> = ({ children }) => {
  const [userProfile, setUserProfile] = useState<IUserProfile>({})
  const { isAuthReady } = useContext(AuthProviderContext)

  useEffect(() => {
    const getUserProfile = async () => {
      const isUserLoggedIn = await authService.isAuthenticated()

      if (!isUserLoggedIn) {
        return
      }
      try {
        const { result } = await userApiInstance.get<unknown, IGetProfileResponse>('/me')
        setUserProfile(result)
        tracker?.identifyUser(result)
      } catch (error) {
        // Error fetching user profile - likely due to API/network issues
        // eslint-disable-next-line no-console
        console.warn('Failed to fetch user profile:', (error as Error)?.message || 'Unknown error')
      }
    }

    if (isAuthReady) {
      // eslint-disable-next-line no-void
      void getUserProfile()
    }
  }, [isAuthReady])

  return <UserProfileContext.Provider value={userProfile}>{children}</UserProfileContext.Provider>
}
